import React, { useState, useEffect } from 'react';

// This slot previously rotated ten invented testimonials with names, cities and
// pass claims. They were removed rather than reworded: fabricated endorsements
// breach CAP Code 3.45 (testimonials must be genuine, held on file and
// verifiable) and are a banned practice under the DMCCA 2024, which gives the
// CMA direct fining powers. The audience here is immigration applicants, which
// is exactly the vulnerable-consumer context regulators weight most heavily.
//
// Replaced with claims that are true today and checkable against the product.
// Keep it that way: only add a real quote once a real customer has given one in
// writing, and keep that permission on file.
const facts = [
  {
    icon: "💷",
    headline: "Full refund if you don't pass",
    detail: "Complete all 45 mock exams and still fail the official test, and we refund your £7.99 in full."
  },
  {
    icon: "📚",
    headline: "453 flashcards across 12 modules",
    detail: "Covering every section of the official handbook. Free, no sign-up, no card details."
  },
  {
    icon: "📝",
    headline: "1,080 practice questions",
    detail: "45 full-length mock exams, each timed to 45 minutes and marked like the real test."
  },
  {
    icon: "🎯",
    headline: "3 full mock exams free",
    detail: "Try the real exam format before deciding whether Premium is worth it to you."
  },
  {
    icon: "🔓",
    headline: "One-off £7.99, no subscription",
    detail: "A single payment. Nothing recurring, nothing to cancel later."
  },
  {
    icon: "✓",
    headline: "Content reviewed August 2026",
    detail: "Questions and study material checked against the current official handbook."
  }
];

export default function TestimonialsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % facts.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full max-w-lg mx-auto bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl p-6 shadow-sm relative overflow-hidden mt-6">
      <h4 className="text-xs font-bold text-indigo-600 dark:text-indigo-400 uppercase tracking-wider mb-3 text-center">What You Get</h4>
      <div className="min-h-[110px] flex flex-col justify-center transition-all duration-500 ease-in-out">
        <p className="text-2xl text-center mb-2" aria-hidden="true">
          {facts[currentIndex].icon}
        </p>
        <p className="text-sm font-bold text-slate-800 dark:text-slate-100 text-center mb-1">
          {facts[currentIndex].headline}
        </p>
        <p className="text-xs text-slate-600 dark:text-slate-300 text-center">
          {facts[currentIndex].detail}
        </p>
      </div>
      {/* The dots stay visually small — they are an indicator, not a control
          anyone hunts for — but `u-tap-halo` gives each one a 44px touch area,
          so they are no longer 6x6px hit targets on a phone. */}
      <div className="flex justify-center gap-4 mt-4">
        {facts.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            className={`u-tap-halo h-1.5 rounded-full transition-all ${
              currentIndex === idx ? 'bg-action-600 w-4' : 'bg-ink-300 w-1.5'
            }`}
            aria-label={`Go to item ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
